import { useEffect, useRef } from "react";
import { useListContext } from "react-admin";
import { useLocation, useNavigate } from "react-router-dom";
import { secureJSONParse } from "../utils/tools";
import isEqual from "lodash/isEqual";

export const NamespacedURLSearchParams = (namespace, search) => {
  const urlParams = new URLSearchParams(search);

  const get = () => {
    const namespaceParamsString = urlParams.get(namespace);
    return namespaceParamsString ? JSON.parse(namespaceParamsString) : {};
  };

  const applyParams = (newParams) => {
    urlParams.set(namespace, JSON.stringify(newParams));
    return urlParams;
  };

  const set = (key, value) => {
    const currentParams = get();
    return applyParams({ ...currentParams, [key]: value });
  };

  const getAll = () =>
    Object.fromEntries(
      urlParams.entries().map(([key, value]) => [key, secureJSONParse(value)])
    );

  return { get, set, getAll, urlParams };
};

const _label = "ListParamsWatcher";
export const ListParamsWatcher = ({ namespace }) => {
  const label = `${_label}: ${namespace}`;
  const firstRun = useRef({
    page: true,
    perPage: true,
    sort: true,
    order: true,
    filter: true,
    displayedFilters: true,
  });

  const navigate = useNavigate();
  const namespacedURLSearchParams = NamespacedURLSearchParams(
    namespace,
    useLocation().search
  );
  const reload = () =>
    navigate(
      { search: namespacedURLSearchParams.urlParams.toString() },
      { replace: true }
    );

  const namespacedParams = namespacedURLSearchParams.get();
  const setNamespacedParam = (key, value) => {
    const old_value = namespacedParams[key];
    if (firstRun.current[key]) {
      console.log(`${label}: ${key}: first run`);
      firstRun.current[key] = false;

      if (old_value) {
        console.log(`${label} ${key}: prevent override`, old_value, value);

        return;
      }
    }

    if (isEqual(old_value, value)) {
      console.log(`${label}: ${key}: skip same value`, value);
      return;
    }

    if (key != "page") {
      namespacedURLSearchParams.set("page", 1);
    }

    console.log(`${label}: ${key}: Updating`, old_value, value);

    namespacedURLSearchParams.set(key, value);
    reload();
  };

  const { page, perPage, sort, filterValues, displayedFilters, setFilters } =
    useListContext();

  useEffect(() => {
    setNamespacedParam("page", page);
  }, [page]);
  useEffect(() => {
    setNamespacedParam("perPage", perPage);
  }, [perPage]);
  useEffect(() => {
    setNamespacedParam("sort", sort.field);
    setNamespacedParam("order", sort.order);
  }, [sort]);
  useEffect(() => {
    setNamespacedParam("filter", filterValues);
  }, [filterValues]);
  useEffect(() => {
    setNamespacedParam("displayedFilters", displayedFilters);
  }, [displayedFilters, setFilters]);

  return null;
};
